// declare all characters
const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export const randomString = (size = 12) => {
  let result = ''
  const charactersLength = characters.length
  for (let i = 0; i < size; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result
}

const getCheckByte = (value) => {
  let result = 0
  for (let i = 0; i < value.length; i++) {
    result = (result + value.charCodeAt(i)) % 255
  }

  return `0${result.toString(16)}`.slice(-2)
}

export const randomStringCS = (prefix = '', size = 12) => {
  const result = prefix + randomString(size - 2)
  const checkByte = getCheckByte(result)
  return result + checkByte
}

export const validateStringCS = (value) => {
  const data = value.substring(0, value.length - 2)
  const checkByte = value.substring(value.length - 2)
  const generatedCheckByte = getCheckByte(data)
  return generatedCheckByte === checkByte
}
